import { render, staticRenderFns } from "./createVSPrescription.vue?vue&type=template&id=acc07370&scoped=true&"
import script from "./createVSPrescription.vue?vue&type=script&lang=js&"
export * from "./createVSPrescription.vue?vue&type=script&lang=js&"
import style0 from "./createVSPrescription.vue?vue&type=style&index=0&id=acc07370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc07370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acc07370')) {
      api.createRecord('acc07370', component.options)
    } else {
      api.reload('acc07370', component.options)
    }
    module.hot.accept("./createVSPrescription.vue?vue&type=template&id=acc07370&scoped=true&", function () {
      api.rerender('acc07370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Prescription/createVSPrescription.vue"
export default component.exports